import { render, staticRenderFns } from "./workClose.vue?vue&type=template&id=0fae6fdb&"
import script from "./workClose.vue?vue&type=script&lang=js&"
export * from "./workClose.vue?vue&type=script&lang=js&"
import style0 from "./workClose.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports